// Party display policy for financial documents: plucks the contact fields the party card renders,
// and derives the avatar initials.

export interface FinancialDocumentPartyView {
  readonly name: string;
  readonly phone: string;
  readonly email: string;
}

/** Tolerant pluck: the party bind holds an embedded ref whose name may arrive as `friendlyName`. */
export function financialDocumentPartyView(value: unknown): FinancialDocumentPartyView {

  if (!value || typeof value !== 'object') return { name: '', phone: '', email: '' };
  const party = value as { name?: string; phone?: string; email?: string; friendlyName?: string };
  return {
    name: party.name || party.friendlyName || '',
    phone: party.phone || '',
    email: party.email || '',
  };
}

export function financialDocumentPartyInitials(name: string): string {

  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}
